import { FC } from 'react'
import { RouteObject, useLocation } from 'react-router-dom'
import { SamplePackDetails } from '../features/details-page'
import { LazyComponent } from '../features/lazy-component'
import { Segment } from '../features/segment'

const SamplePackDetailsPage: FC = () => {
  const { pathname } = useLocation()
  return (
    <Segment.ViewTracker attributes={{ path: '/sample-packs', pack: pathname.split('/')[2] }}>
      <LazyComponent>
        <SamplePackDetails />
      </LazyComponent>
    </Segment.ViewTracker>
  )
}

export const SamplePacksRoute: RouteObject = {
  path: '/sample-packs/:samplePackId/*',
  element: <SamplePackDetailsPage />
}
